import React from 'react';
import { useReportViewEvent } from '../../tracking/hooks';

const PrivateCustomerInfoPage = (): JSX.Element => {
  useReportViewEvent({
    pageTitle: 'error',
  });
  return (
    <>
      <div data-testid="private-customer-info-page" className="margin-vertical-xl align-center">
        <h1 className="margin-none">
          Hinweis für den Zugang zum
          <br /> API Self-Service-Portal
        </h1>
        <div>
          <img
            alt="errorImage"
            src="//www.static-immobilienscout24.de/statpic/error-page/1b897f0c0bc19ff74d68346f75fdef25_IS24_ErrorPage.svg"
            onError={() => "this.src='//etc/designs/is24/img/immoscout24.png';this.onerror=null;"}
            style={{ height: 200 }}
          />
          <p className="margin-bottom-s">
            Aktuell stellen wir unsere technische Schnittstelle nur bestimmten Kundengruppen zur Verfügung.
            <br /> Wir arbeiten daran dies zu erweitern.
          </p>

          <p className="margin-bottom-l margin-top-l">
            Um Ihr Interesse an unseren API-Produkten besser zu verstehen, wenden Sie sich gern per E-Mail an
            <br /> <a href="mailto: schnittstellen@immobilienscout24.de">schnittstellen@immobilienscout24.de</a>
          </p>
          <p className=" margin-top-xxl">Vielen Dank für Ihr Verständnis!</p>
        </div>
      </div>
    </>
  );
};

export { PrivateCustomerInfoPage };
